import React from "react";
import Markdown from "../utility/markdown";
import getRatio from "../utility/getRatio";
import RichButton from "../utility/rich-button";

const TextText = ({component}) => {
    const {left, right} = getRatio(component.ratio)

    return (
        <div className="m-auto md:w-11/12 grid grid-cols-1 md:grid-cols-12 md:gap-8 mb-14">
            <div className={`${left} leading-none mb-8 lg:mb-0 text-${component.contentLeftAlignment}`}>
                <Markdown body={component.contentLeft.data.contentLeft}></Markdown>
                {component.buttonsLeft?.map((button)=>(
                    <RichButton key={button.id} button={button} />
                ))}
            </div>
            <div className={`${right} leading-none text-${component.contentRightAlignment}`}>
                <Markdown body={component.contentRight.data.contentRight}></Markdown>
                {component.buttonsRight?.map((button)=>(
                    <RichButton key={button.id} button={button} />
                ))}
            </div>
        </div>
    )
}

export default TextText